import React from 'react';
import './socials.scss';

function SocialList() {
  return (
    <div className='socials'>
      <ul>
        <li>
          <a href='https://github.com/effy-yin/' target='_blank' rel='noreferrer'>
            <i className='icn-github'></i>
          </a>
        </li>

        {/* <li>
          <Link to='https://twitter.com/dodoroy_' target='_blank' rel='noreferrer'>
            <i className='icn-twit'></i>
          </Link>
        </li>

        <li>
          <Link to='https://www.instagram.com/effy.yin/' target='_blank' rel='noreferrer'>
            <i className='icn-pint'></i>
          </Link>
        </li> */}

        <li>
          <a href='https://www.linkedin.com/in/xiaohui-yin-89638168/' target='_blank' rel='noreferrer'>
            <i className='icn-link'></i>
          </a>
        </li>
      </ul>
    </div>
  );
}

export default SocialList;
